import {type MutableRefObject, useEffect, useRef} from 'react';
// eslint-disable-next-line no-restricted-imports
import {useSelector} from 'react-redux';

/**
 * Use this when you need to select state values that change often.
 * e.g. selecting form values that you _only_ need to use in a callback such as submit.
 *
 * WARNING: This will NOT update your component and values should NOT be used for rendering!
 */
export const useSelectorRef = <TState = {}, TSelected = unknown>(
    selector: (state: TState) => TSelected,
): MutableRefObject<TSelected> => {
    const selected = useSelector(selector);
    const ref = useRef(selected);
    useEffect(() => {
        ref.current = selected;
    }, [selected]);
    return ref;
};
